import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { IconoirOpenNewWindow } from '@ey-xd/motif-icon';
import { ModalSizes, MotifButtonModule, MotifIconModule, MotifModal } from '@ey-xd/ng-motif';
import { LongTextModalComponent, LongTextModalConfig } from './long-text-modal/long-text-modal.component';

@Component({
  selector: 'app-long-text',
  standalone: true,
  imports: [MotifIconModule, MotifButtonModule],
  templateUrl: './long-text.component.html',
  styleUrl: './long-text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LongTextComponent {
  readonly #modal = inject(MotifModal);

  readonly icon = IconoirOpenNewWindow;

  readonly title = input.required<string>();
  readonly text = input.required<string>();
  readonly maxLength = input<number>(350);

  readonly tooLong = computed(() => this.text().length > this.maxLength());
  readonly shortText = computed(() => {
    const text = this.text();
    if (!this.tooLong()) {
      return text;
    }
    return text.slice(0, this.maxLength()) + '&hellip;';
  });

  public openModal(): void {
    this.#modal.open(LongTextModalComponent, {
      size: ModalSizes.XL,
      data: new LongTextModalConfig(this.title(), this.text()),
    });
  }
}
